<script setup lang="ts">
import type { CarouselNextPrevProps } from './interface';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import { ArrowLeftIcon } from '@radix-icons/vue';

import { useCarousel } from './useCarousel';

const props = defineProps<CarouselNextPrevProps>();

const { orientation, canScrollPrev, scrollPrev } = useCarousel();
</script>

<template>
	<Button
		:disabled="!canScrollPrev"
		:class="
			cn(
				'absolute h-8 w-8 touch-manipulation border-none bg-primary/40 p-0 opacity-0 transition-all delay-300 ease-in-out hover:bg-primary',
				orientation === 'horizontal'
					? 'top-1/2 -translate-y-1/2'
					: 'left-1/2 -translate-x-1/2 rotate-90',
				props.isMouseOverCarousel && orientation === 'horizontal'
					? 'left-3 opacity-100'
					: '-left-12',
				props.isMouseOverCarousel && orientation === 'vertical'
					? 'top-3 opacity-100'
					: '-bottom-12',
				props.class
			)
		"
		@click.stop.prevent="scrollPrev"
	>
		<slot>
			<ArrowLeftIcon class="size-4 text-current" />
			<span class="sr-only">Previous Slide</span>
		</slot>
	</Button>
</template>
